export const chooseSalespersonButton = 'choose salesperson';
export const chooseSalespersonTitle = 'Select a salesperson';
export const chooseSalespersonDescription = 'Who will be the salesperson?';
export const chooseSalespersonEmptySet = 'No salesperson found with that name';
export const chooseSalespersonPlaceholder = 'salesperson name...';
export const errorPickingSalesperson = 'Error updating salesperson!';
export const successUpdatingSalesperson = 'Updated salesperson!';
export const addButton = 'Add';
export const cancelButton = 'Cancel';
export const noSalesperson = 'No salesperson';
